// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { createSelector } from '@ngrx/store';
import { accessManagementSelector } from '../index';
import { OrganizationDetailsState } from './organization-details.interfaces';

export const selectOrganizationDetails = createSelector(accessManagementSelector, state => state.organizationDetails);

export const selectOrganizationDetail = (id: string) =>
  createSelector(selectOrganizationDetails, getOrganizationDetails(id));

export function getOrganizationDetails(orgId: string) {
  return (state: OrganizationDetailsState) => {
    if (!state[orgId]) {
      return undefined;
    }

    return state[orgId].details.data;
  };
}



// WEBPACK FOOTER //
// ./src/app/access-management/state/organization-details/organization-details.selectors.ts